import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import useCrmObjectTypeListingFilterState from 'framework-listing-lib/internal/hooks/useCrmObjectTypeListingFilterState';
import { createZustandStoreContext } from 'framework-listing-lib/internal/store/zustand';
import { createExpandableObjectIdsStore } from '../store/expandableObjectIdsStore';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmObjectTypeListingContext = /*#__PURE__*/createContext(null);
const {
  ContextProvider: ExpandableObjectIdsContext,
  useStore: useExpandableObjectIdsStore
} = createZustandStoreContext();
export default function CrmObjectTypeListingClientProvider(t0) {
  "use memo";

  const $ = _c(33);
  const {
    associationSpecs,
    calendarProps,
    children,
    emptyStateFilter,
    fetcher,
    folderProps,
    hiddenFilter: hiddenFilterProp,
    initialFilter,
    inlineEditProps,
    quickFilterProps,
    searchInputProps
  } = t0;
  const [uncontrolledFolderId, setUncontrolledFolderId] = useState(undefined);
  let t1;
  if ($[0] !== folderProps || $[1] !== uncontrolledFolderId) {
    t1 = folderProps !== null && folderProps !== void 0 && folderProps.onSetCurrentFolderId ? {
      onSetCurrentFolderId: folderProps.onSetCurrentFolderId,
      currentFolderId: folderProps.currentFolderId
    } : {
      onSetCurrentFolderId: setUncontrolledFolderId,
      currentFolderId: uncontrolledFolderId
    };
    $[0] = folderProps;
    $[1] = uncontrolledFolderId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    onSetCurrentFolderId,
    currentFolderId
  } = t1;
  let t2;
  if ($[3] !== calendarProps || $[4] !== currentFolderId || $[5] !== hiddenFilterProp || $[6] !== initialFilter) {
    t2 = {
      calendarProps,
      hiddenFilter: hiddenFilterProp,
      initialFilter,
      folderId: currentFolderId
    };
    $[3] = calendarProps;
    $[4] = currentFolderId;
    $[5] = hiddenFilterProp;
    $[6] = initialFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    deletedObjects,
    filters,
    filterStateSource,
    hasPropertyFilter,
    hiddenFilter,
    isFilterFromCustomView,
    onSetDeletedObjects,
    onSetFilters
  } = useCrmObjectTypeListingFilterState(t2);
  let t3;
  if ($[8] !== associationSpecs || $[9] !== calendarProps || $[10] !== currentFolderId || $[11] !== deletedObjects || $[12] !== emptyStateFilter || $[13] !== fetcher || $[14] !== filterStateSource || $[15] !== filters || $[16] !== folderProps || $[17] !== hasPropertyFilter || $[18] !== hiddenFilter || $[19] !== initialFilter || $[20] !== inlineEditProps || $[21] !== isFilterFromCustomView || $[22] !== onSetCurrentFolderId || $[23] !== onSetDeletedObjects || $[24] !== onSetFilters || $[25] !== quickFilterProps || $[26] !== searchInputProps) {
    t3 = {
      associationSpecs,
      calendarProps,
      deletedObjects,
      emptyStateFilter,
      fetcher,
      filters,
      filterStateSource,
      folderId: currentFolderId,
      folderProps,
      hasPropertyFilter,
      hiddenFilter,
      initialFilter,
      inlineEditProps,
      isFilterFromCustomView,
      onSetDeletedObjects,
      onSetFilters,
      onSetFolderId: onSetCurrentFolderId,
      quickFilterProps,
      searchInputProps
    };
    $[8] = associationSpecs;
    $[9] = calendarProps;
    $[10] = currentFolderId;
    $[11] = deletedObjects;
    $[12] = emptyStateFilter;
    $[13] = fetcher;
    $[14] = filterStateSource;
    $[15] = filters;
    $[16] = folderProps;
    $[17] = hasPropertyFilter;
    $[18] = hiddenFilter;
    $[19] = initialFilter;
    $[20] = inlineEditProps;
    $[21] = isFilterFromCustomView;
    $[22] = onSetCurrentFolderId;
    $[23] = onSetDeletedObjects;
    $[24] = onSetFilters;
    $[25] = quickFilterProps;
    $[26] = searchInputProps;
    $[27] = t3;
  } else {
    t3 = $[27];
  }
  const value = t3;
  let t4;
  if ($[28] !== children) {
    t4 = /*#__PURE__*/_jsx(ExpandableObjectIdsContext, {
      initializeStore: _temp,
      children: children
    });
    $[28] = children;
    $[29] = t4;
  } else {
    t4 = $[29];
  }
  let t5;
  if ($[30] !== t4 || $[31] !== value) {
    t5 = /*#__PURE__*/_jsx(CrmObjectTypeListingContext.Provider, {
      value: value,
      children: t4
    });
    $[30] = t4;
    $[31] = value;
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  return t5;
}
function _temp() {
  return createExpandableObjectIdsStore();
}
export function useCrmObjectType() {
  "use memo";

  const context = useContext(CrmObjectTypeListingContext);
  if (context === null) {
    throw new Error("useCrmObjectType must be used within a CrmObjectTypeListingClientProvider");
  }
  return context;
}
export { useExpandableObjectIdsStore };